module.exports = __webpack_public_path__ + "699bbe4ef3cd37d477b27a621dd7feb2.MP3";